import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import axios from "axios";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        Sidebar_drawer: null,
        Customizer_drawer: false,
        SidebarColor: '#171515',
        SidebarBg: '',
        profilePic: null,
        completeUserData: {},
        isLoggedIn: !!localStorage.getItem('isLoggedIn'),
        userRole: localStorage.getItem('userRole'),
        userName: localStorage.getItem('userName'),
        userType: localStorage.getItem('userType'),
    },
    mutations: {
        loginUser(state) {
            state.isLoggedIn = true
            localStorage.setItem('isLoggedIn', true)
        },
        logoutUser(state) {
            axios({
                method: "GET",
                url: "/user/logout",
                headers: {
                    "x-auth-token": localStorage.getItem("token")
                }
            }).then(response => {
                if (response.data) {
                    state.isLoggedIn = false
                    state.userType = 'Admin'
                    localStorage.setItem("userType", 'Admin');
                    localStorage.removeItem('isLoggedIn');
                    localStorage.removeItem("token");
                    localStorage.removeItem("userRole");
                    localStorage.removeItem("userName");
                    state.isLoggedIn = "";
                    if (window.location.pathname != '/') {
                        router.push('/')
                    }
                }
            })
        },
        // userRole(state, item) {
        //     state.userRole = item
        //     if (item == "Admin") {
        //         state.isAdmin = true
        //         localStorage.setItem('isAdmin', true)
        //     } else if (item == "SubAdmin") {
        //         state.isSubAdmin = true
        //         localStorage.setItem('isSubAdmin', true)
        //     }
        //     localStorage.setItem("userRole", item);
        // },
        userName(state, item) {
            state.userName = item
            localStorage.setItem("userName", item);
        },
        userType(state, item) {
            state.userType = item
            localStorage.setItem("userType", item);
        },
        userData(state, payload) {
            state.profilePic = payload.photo
            state.completeUserData = payload
        },
        myPic(state, item) {
            state.profilePic = item
        },
        sessionOut(state) {
            localStorage.removeItem("token");
            localStorage.removeItem('isLoggedIn');
            state.isLoggedIn = false
            router.push('/')
        }
    },
    actions: {

    }
})